import {
  useExecutiveReportFields,
  buildPresentation,
} from '@features/executive-report/subdomains/rsl';
import { presentationToFile } from '@features/powerpoint';
import { Campaign, GetCampaignParams } from '@features/campaigns';
import { useCurrentUser } from '@features/users';
import { stringify } from 'qs';
import { useNavigate } from 'react-router-dom';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import { clientDefaultValues } from '@features/executive-report/subdomains/rsl';
import { RslReportsParams } from '@features/campaigns/subdomains/rsl';

type RslExecutiveReportDownloadProps = {
  campaignId: Campaign['id'];
  reportParams: Omit<RslReportsParams, 'campaignId'>;
  campaignParams: GetCampaignParams;
};

export const RslExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: RslExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const presentation = buildPresentation({
        ...data,
        brandLogo: null,
        customFields: clientDefaultValues(data.campaign.name),
      });

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/rsl/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
